import { TextLink } from "@vds/buttons";
import { Col, Grid, Row } from "@vds/grids";
import { Tooltip } from "@vds/tooltips";
import { useImageUtils } from "hooks";
import { MarginSpacerM } from "pages/Checkout/components/Common/styleTag";
import {  setPlansFirstAllDevices, setPlansFirstDevices } from "pages/Mobility/ducks/MobilitySlice";
import { setLinesCount, setLinesRemain, setLinesUpdated, setLinesUpdatedForByod } from "pages/PlanFirst/ducks/PlanFirstSlice";
import PlansDetailsModal from "pages/PlansFirstNew/Components/PlansDetailsModal";
import PlansFirstLinesModal from "pages/PlansFirstNew/Components/PlansFirstLinesModal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { Body } from "@vds/typography";



const GridwallPlansFirstDevices = ({
  selectedProducts = [],
  ...props
}) => {
  const { t } = useTranslation(["plans", "plans-first-new"]);
  const globalData = useSelector((state) => state.GlobalData);
  const pageData = useSelector((state) => state.MobilityPage);
  const PlanFirstPageData = useSelector((state) => state.PlanFirst);
  selectedProducts = pageData?.plansFirstDevices
  let linesCount = PlanFirstPageData?.linesCount
  const linesRemain = PlanFirstPageData?.linesRemain === 0 ? linesCount - Object.keys(selectedProducts ?? {}).length : PlanFirstPageData?.linesRemain
  const selectedKeys = Object.keys(selectedProducts ?? {});

  const [planId, setPlanId] = useState(PlanFirstPageData?.plansFirstData?.planId)
  const [selectedPlan, setSelectedPlan] = useState(PlanFirstPageData?.plans?.plans?.[planId]);
  const [showPlansDetailsModal, setShowPlansDetailsModal] = useState(null);
  const [showLinesDetailsModal, setShowLinesDetailsModal] = useState(null);


  const plansAEM = t("plans.planFeatures", { returnObjects: true });
  const plan5G = t("plans-first-new.plus5G", {
    ns: "plans-first-new",
    returnObjects: true,
  });
   const pro5G = t("plans-first-new.pro5G", {
    ns: "plans-first-new",
    returnObjects: true,
   });
   const start5G = t("plans-first-new.start5G", {
    ns: "plans-first-new",
    returnObjects: true,
  });
  const isMobile = useMediaQuery({
    query: "(max-width: 1024px)",
  });
  const [planIdForModal, setPlanIdForModal] = useState(planId);
  const dispatch = useDispatch()
 
  useEffect(() => {
    const addToCartResponse = pageData?.addToCartResponse   
    let packages = addToCartResponse?.response?.cart?.packages;
    let fromSession = false;
    if(!packages && Object.keys(packages || {}).length === 0) {
      packages = globalData?.sessionCartData?.apiResponse?.prospectFlowData?.cart?.packages;
      fromSession = true
    }

    packages = Object.fromEntries(Object.entries(packages || {}).filter(([key, value]) => value?.plan?.pricePlanCode === planId))

    if(fromSession || PlanFirstPageData?.linesUpdated) {
      updateAllDevices(packages)
    }
  }, [pageData?.addToCartResponse])

  const updateAllDevices = (pkgs) => {

    let a = []
    let deviceCountMap = new Map()
      Object.entries(pageData?.plansFirstDevices).map(([key, value], index) => {
        a[index] = value.packageId;
        deviceCountMap.set(value.deviceSku, deviceCountMap.get(value.deviceSku) ? deviceCountMap.get(value.deviceSku) + 1 : 1)
      })

      let packages = Object.fromEntries(
        Object.entries(pkgs || {}).filter(([key, value]) => {
          if(a.includes(key) || key.includes('LINE_')) {
            if(deviceCountMap.get(value?.deviceSku) > 0) {
              deviceCountMap.set(value?.deviceSku, deviceCountMap.get(value?.deviceSku) - 1) 
            }
            return true
          } else {
            let device = Object.entries(pageData?.plansFirstDevices).filter(([pfKey, pfVal]) => {
              return pfVal?.deviceSku === value?.deviceSku ? true : false
            })
            if(device?.length > 0 && deviceCountMap.get(value?.deviceSku) > 0) {
              deviceCountMap.set(value?.deviceSku, deviceCountMap.get(value?.deviceSku) - 1) 
              return true
            }
            return false
          }
        })
      );

    

    const packageIds = Object.keys(packages || {}).filter((key, _line) => !key.toUpperCase().includes("LINE"))
    const linePackageIds = Object.keys(packages || {}).filter((key, _line) => key.toUpperCase().includes("LINE"))

    

    if(packages && Object.keys(packages).length > 0) {
    let deviceIdsForDeleteAction = {}
    let d = 0
    linePackageIds?.length > 0 && linePackageIds.forEach(id => {
      const device = packages[id]
      const deviceDetails = {
        "packageId": id,
        "packageType": device?.packageType,
        "lineId": device?.lineId,
        "lineIndex": device?.lineId?.substring(device?.lineId?.indexOf("_") + 1)
      }
      deviceIdsForDeleteAction[d++] = deviceDetails
    })
    packageIds?.length > 0 && packageIds.forEach(id => {
      const device = packages[id]
    
        const deviceDetails = {
          "packageId": id,
          "packageType": device?.packageType,
          "lineId": device?.lineId,
          "lineIndex": device?.lineId?.substring(device?.lineId?.indexOf("_") + 1)
        }
      deviceIdsForDeleteAction[d++] = deviceDetails
 
    })


    let newSelected = []
      let i = 0;
      packageIds.forEach(id => {
        const device = packages[id]
       
          let img = device?.imageSet?.substring(0, device.imageSet.indexOf("?req=set,json") > 0 ? device.imageSet.indexOf("?req=set,json") : device.imageSet.length)

          const deviceDetails = {
            "deviceName": device.packageDesc,
            "image": img,
            "packageId": id,
            "packageType": device?.packageType,
            "lineId": device?.lineId,
            "deviceSku": device?.deviceSku,
            "deviceId": device?.deviceId,
            "lineIndex": device?.lineId?.substring(device?.lineId?.indexOf("_") + 1),
            "isByod": device?.byod,
            "capacity": device?.capacity,
            "color": device?.color
          }

          newSelected[i++] = deviceDetails
      

      })

      let linesRemain = Object.keys(linePackageIds || {}).length
      dispatch(setLinesRemain(linesRemain));

      linesCount = newSelected?.length + linesRemain
      dispatch(setLinesCount(linesCount))

      dispatch(setPlansFirstDevices(newSelected))
      dispatch(setPlansFirstAllDevices(deviceIdsForDeleteAction))
      dispatch(setLinesUpdated(false))
      dispatch(setLinesUpdatedForByod(true))
    } else {
     
      dispatch(setLinesCount(0))
      dispatch(setLinesRemain(0));
      dispatch(setPlansFirstDevices([]))
      dispatch(setPlansFirstAllDevices([]))
    }
  }



  return linesCount && linesCount > 0 ? (
    <Grid>
      <Row>
        <Col colSizes={{ mobile: 6, tablet: 12, desktop: 12 }}>
          <MainContainer>
            <PlanContainer>
              <PlanTitleContainer isMobile={isMobile}>
                <span>{(selectedPlan?.displayName)?.toLowerCase()?.includes("flexible") ? "Flexible Business" : "Business Unlimited"}</span>
                <div><span style={{ color:"#EE0000" }}>{(selectedPlan?.displayName)?.toLowerCase()?.includes("plus") ? plan5G :
                    (selectedPlan?.displayName)?.toLowerCase()?.includes("pro") ? pro5G :
                      (selectedPlan?.displayName)?.toLowerCase()?.includes("start") ? start5G : (selectedPlan?.displayName)?.toLowerCase()?.includes("flexible") ?
                        (selectedPlan?.displayName)?.substring(selectedPlan?.displayName?.indexOf('-') + 1)?.trim()
                      : " "}
                  </span>                   
                  <span> Smartphone</span></div>

              </PlanTitleContainer>
                <TextLinkWrapper>
                <Body size="small"><TextLink onClick={() => setShowPlansDetailsModal(true)}>
                {t("plans-first-new.planDetails", { ns: "plans-first-new" })}
                </TextLink>
                  </Body>
                  </TextLinkWrapper>
            </PlanContainer>
              <MarginSpacerM></MarginSpacerM>

            <ButtonWrapper>
              <DevicesContainer>
                <>
                  <DeviceDataContainer>
                    <div className="deviceText"><Body size="small">Selecting device {Object.keys(selectedProducts ?? {})?.length + 1 > linesCount ? linesCount : Object.keys(selectedProducts ?? {})?.length + 1} of {linesCount}</Body></div>
                    <Body size="small"><TextLink className="deviceTextNormal" onClick={() => setShowLinesDetailsModal(true)}>Edit</TextLink></Body>
                  </DeviceDataContainer>
                  <span style={{alignSelf:'start !important'}} >
                  <TextLink className="deviceTextMobile"  onClick={() => setShowLinesDetailsModal(true)}>Edit</TextLink>
                  </span>
                </>
                <>
                 
                    {!isMobile && <>
                      <TileWrapper>
                      {Array.from({ length: linesCount })
                        .fill(1)
                        .map((item, index) => (
                          <DeviceTile
                            key={
                              selectedProducts[selectedKeys[index]]?.packageId ?? index
                            }
                            item={selectedProducts[selectedKeys[index]]}
                            index={index}
                            currentSelectionNumber={Object.keys(selectedProducts ?? {})?.length === index || 
                                                    ( index + 1 === linesCount && Object.keys(selectedProducts ?? {})?.length === linesCount)}
                            linesCount={linesCount}
                          />
                        ))}
                        </TileWrapper>
                    </>
                    }
                  
                </>
              </DevicesContainer>
              { showPlansDetailsModal && <PlansDetailsModal showModal={true} plansData={plansAEM[planIdForModal]} planTitle={selectedPlan?.displayName} close={setShowPlansDetailsModal} /> }
              { showLinesDetailsModal && <PlansFirstLinesModal showModal={true} close={setShowLinesDetailsModal} /> }
            </ButtonWrapper>
          </MainContainer>
        </Col>
      </Row>
    </Grid>
  ) : (
    <></>
  );
};

const DeviceTile = (props) => {
  const { getImageLink } = useImageUtils();
  return (
    <ImageTileContainer
      style={{
        borderColor: props.currentSelectionNumber ? "#1B1D1F" : "#D8DADA",
        width:props.linesCount>1 ? "80px" : "56px"
      }}
    >
      {props.item && (
        <>
          <Tooltip size="small" renderAnchorElement={() =>
            <ImageTileContent style={{margin: !props?.item?.image ? "5px 15px" : props.linesCount>1 ?"5px":"5px 0px 0px 0px"}}>
              {props?.item?.image ? <img
                width="90px"
                height="90px"
                src={getImageLink(props?.item?.image, 250, 250)}
              />: <ByodImage/>}
            </ImageTileContent>} surface="dark">
            <div>
              <span>{props?.item?.deviceName}</span>
            </div>
            <div>
              <span>{`${props?.item?.capacity ? props?.item?.capacity : ""}`}</span>
              <span>&nbsp;{`${props?.item?.color ? props?.item?.color : ""}`}</span>
            </div>
          </Tooltip>
        </>
      )}
      {!props.item && (
        <ImageTileContentNew>
          <div className="WithoutCt"></div>
        </ImageTileContentNew>
      )}
    </ImageTileContainer>
  );
};

const MainContainer = styled.div`
	display: flex; 
  flex-direction: row;
  width: 100% !important;
  flex-wrap:wrap;
  padding-top:17.5px;
  font-family:'Verizon-NHG-eDS';
  @media only screen and (max-width:767px){
  padding-top:13px;
  }
`;

const PlanContainer = styled.div`
	display: flex; 
  align-items: flex-start;
  flex-direction: column;
  padding-right: 24px;
  max-width: 20% !important;
  font-weight: 700;
 @media only screen and (max-width:767px){
    flex-direction:row;
    flex-wrap:wrap;
  }
`;

const TextLinkWrapper = styled.div`
white-space:nowrap;
margin-top:4px;
@media only screen and (min-width:1023px){
margin-top:8px;
}
`

const PlanTitleContainer = styled.div`
  display: flex;
  align-items: center;
  width: 185px;
  flex-direction: row;
  font-weight: 700;
  color: #000;
  gap: ${({ isMobile }) => (isMobile ? "0.25rem" : "0")};
  @media only screen and (max-width:1024px){
    white-space:nowrap;  
    font-size:14px;
  }
 
  @media only screen and (min-width:1025px){
    flex-wrap:wrap;
    line-height: 20px;
  }
`;

const DevicesContainer = styled.div`
	display: flex; 
  margin-bottom: 1rem;
  align-items: flex-start;
  flex-direction: column;
  padding: 0px 25px;
  font-size: 12px;
  @media only screen and (min-width:391px){
  .deviceTextMobile{
   display:none;
}
   padding: 0px!important;
}
  @media only screen and (max-width:768px){
    padding:5px 0px;
  }
`;

const DeviceDataContainer = styled.div`
  display: flex;
  align-items: left;
  display: flex;
  flex-direction: row;
  color: #000;
  gap: 2rem;
  padding-bottom: 0.5rem;
  padding-top:0.1rem;
 @media only screen and (max-width:390px){

   .deviceTextMobile{
   display:block;
}
   .deviceTextNormal
   {
   display:none;
   } 
}
   @media only screen and (max-width:1024px){
         padding-top:0.5rem;

}
   `;


const Carousel = styled.div``;

const TileWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex: 1;
  max-width: 80% !important;
  @media (max-width: 767px) {
  > div > div >div {
    width:100%;
  }
  .slotContainer{
    width:75px;
  }
  .slotContainer > div > div >div {
    aspect-ratio: 2;
    border: 2px dashed #f6f6f6;
  }
}
  @media (max-width: 767px) {
     {
      max-width: 100% !important;
    }
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  min-width: 100px;
  max-width: 60% !important;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  

  @media (max-width: 1024px) {
   max-width: 100% !important;
    display: flex;
    flex-wrap: wrap;
    
}
`;

const ImageTileContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  height: 60px;
  border-radius: 8px;
  margin-right: 1rem;
  border: 1px solid #D8DADA;
  box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.02);
  @media (max-width: 767px) {
     {
      width: 152px;
      max-height: 64px;
      border-radius: 8px;
      display: flex;
    align-items: center;
    border: none;
}
    }
  }
`;

const ImageTileContentNew = styled.div`
  display: flex;
  margin: 5px;
  background-color:#ffffff !important;
  img {
    height: 48px;
    width: 48px;
  }
  @media (max-width: 767px) {
  .WithoutCt{
    position: absolute !important;
    top: 4px !important;
    font-size: 12px !important;
    font-weight: 400 !important;
    left:25px;

  }
}
`;
const ImageTileContent = styled.div`
  display: flex;
  align-items: flex-start;
  img {
    height: 48px;
    width: 48px;
  }
 
  @media (max-width: 767px) {
    margin: -5px !important;
    img {
      max-width: 100%;
      width: 28px;
      height: 28px;
      object-fit: contain;
      position: absolute;
      top: 10px;
      left:5px
    }
   
  }
`;

export const ByodImage = styled.div`
width: 30px;
height: 50px;
border-style: solid;
border-radius: 9px;
border-width: 2px;
border-color: #A7A7A7;
`;

export default GridwallPlansFirstDevices;
